<template>
  <el-col :span="17" class="footModule">
    <!-- 快捷入口 -->
    <div class="quickAccess">
      <h4 class="title">推荐功能</h4>
      <!-- pop 版 -->
      <ul v-if="!venderType">
        <li class="item" @click="goUrl(0)">
          <img
            src="../../assets/images/home/icon_remake1.png"
            class="icon-x"
            alt=""
          />
          <div class="right">
            <h5>精准营销<img src="@/assets/images/home/tag_new.png" /></h5>
            <span class="desc"
              >精细化客户营销，180+官方人群标签，促进新客首购，提升老客复购，促进转化成交</span
            >
          </div>
        </li>
        <li class="item" @click="goUrl(1)">
          <img
            src="../../assets/images/home/icon_remake2.png"
            class="icon-x"
            alt=""
          />
          <div class="right">
            <h5>
              商品复购<img src="@/assets/images/home/tag_new.png" />
              <!-- <img style="margin-top: -1px;" src="@/assets/images/icon_home.png" alt="" /> -->
            </h5>
            <span class="desc"
              >根据商品复购周期，针对到期未购的客户进行复购营销，提升客户复购率</span
            >
          </div>
        </li>
        <li class="item" @click="goUrl(2)">
          <img
            src="../../assets/images/home/icon_开卡未购会员转化.png"
            class="icon-x"
            alt=""
          />
          <div class="right">
            <!-- <h5>指定号码发送</h5> -->
            <h5>开卡未购会员转化</h5>
            <span class="desc"
              >针对开卡入会一定时间后未购买的客户进行持续转化，提升首购转化率</span
            >
            <!-- <span class="desc">导入/输入私有人群手机号，定向高效营销</span> -->
          </div>
        </li>
        <li class="item" @click="goUrl(3)">
          <img
            src="../../assets/images/home/icon_流失客户召回.png"
            class="icon-x"
            alt=""
          />
          <div class="right">
            <h5>流失客户召回</h5>
            <!-- <img src="@/assets/images/home/tag_new.png" /> -->
            <span class="desc"
              >针对一定时间未成交的客户，自关怀客户发送关怀，唤醒客户记忆进店购买，降低店铺客户流失率</span
            >
          </div>
        </li>
        <li class="item" @click="goUrl(4)">
          <img
            src="../../assets/images/home/icon_自动催付.png"
            class="icon-x"
            alt=""
          />
          <div class="right">
            <h5>自动催付</h5>
            <span class="desc"
              >针对已下单但未付款的订单，自动提醒买家付款，减少下单-付款跳失率</span
            >
          </div>
        </li>
        <li class="item" @click="goUrl(5)">
          <img
            src="../../assets/images/home/icon_自动催评.png"
            class="icon-x"
            alt=""
          />
          <div class="right">
            <h5>自动催评</h5>
            <span class="desc"
              >对于订单完成但是未评价的买家，自动发送短信提醒买家好评，提升店铺DSR</span
            >
          </div>
        </li>
      </ul>
      <!-- 自营版 -->
      <ul v-else>
        <li
          class="item"
          @click="goUrl(item.type)"
          v-for="(item, index) in venderData"
          :key="index"
        >
          <img :src="item.img" class="icon-x" alt="" />
          <div class="right">
            <h5>
              {{ item.title
              }}<img v-if="item.isNew" src="@/assets/images/home/tag_new.png" />
            </h5>
            <span class="desc">{{ item.content }}</span>
          </div>
        </li>
      </ul>
    </div>
  </el-col>
</template>

<script>
import {versionPermissions } from "@/api/homePage";
export default {
  data() {
    return {
      version:{
        accurateMarket: true, //精准营销
        accurateMarketUrl: null,
        autoEvaluation: true, //自动催评
        autoEvaluationUrl: null,
        callCustomerChurn: true,  //流失客户召回
        callCustomerChurnUrl: null,
        conversionUnpurchasedMembers: true, //开卡未购会员转化
        conversionUnpurchasedMembersUrl: null,
        expediting: true, //常规催付
        expeditingUrl: null,
        goodsRepurchase: true, //商品复购
        goodsRepurchaseUrl: null,
        payReminder: true, //付款关怀
        payReminderUrl: null,
        poorEvaluation: true, //中差评安抚
        poorEvaluationUrl: null,
        presaleExpediting: true, //预售尾款催付
        presaleExpeditingUrl: null,
        sendreMind: true, //发货提醒
        sendreMindUrl: null,
        thankEvaluation: true, //好评感谢
        thankEvaluationUrl: null,
        twiceExpediting: true, //二次催付
        twiceExpeditingUrl: null
      },
      myChart: null,
      venderData: [
        {
          title: "精准营销",
          isNew: true,
          content: "精细化客户营销，180+官方人群标签，促进新客首购，提升老客复购，促进转化成交",
          type: 0,
          img: require("../../assets/images/home/icon_remake1.png"),
        },
        {
          title: "商品复购",
          isNew: true,
          content: "根据商品复购周期，针对到期未购的客户进行复购营销，提升客户复购率",
          type: 12,
          img: require("../../assets/images/home/icon_remake12.png"),
        },
        {
          title: "开卡未购会员转化",
          isNew: true,
          content: "针对开卡入会一定时间后未购买的客户进行持续转化，提升首购转化率",
          type: 13,
          img: require("../../assets/images/home/icon_开卡未购会员转化.png"),
        },
        {
          title: "流失客户召回",
          isNew: true,
          content: "针对一定时间未成交的客户，自关怀客户发送关怀，唤醒客户记忆进店购买，降低店铺客户流失率",
          type: 14,
          img: require("../../assets/images/home/icon_流失客户召回.png"),
        },
        {
          title: "自动催付",
          isNew: false,
          content: "针对已下单但未付款的订单，自动提醒买家付款，减少下单-付款跳失率",
          type: 15,
          img: require("../../assets/images/home/icon_自动催付.png"),
        },
        {
          title: "自动催评",
          isNew: false,
          content: "对于订单完成但是未评价的买家，自动发送短信提醒买家好评，提升店铺DSR",
          type: 16,
          img: require("../../assets/images/home/icon_自动催评.png"),
        },
      ],
    };
  },
  computed: {
    venderType() {
      // 是否为自营店铺
      return this.$store.getters.loginUserInfo.venderType;
    },
  },
  mounted() {
    // this.drawactivityEcharts();
    // window.addEventListener('resize', () => {
    //     this.myChart.resize();
    // })
    this.versionPermissions()
  },
  methods: {
    versionPermissions(){
     versionPermissions().then((res)=>{
        this.version = res.data
        sessionStorage.setItem('versionOne',JSON.stringify(res.data))
        console.log("1111",this.version);
     }).catch(()=>{})
    },
    goUrl(type) {
      var goUrlClick = JSON.parse(sessionStorage.getItem('versionOne')) ;
      //判断该店铺是否有权限
      var url = "",
        index = 0;
      if (type === 0) {
        if(goUrlClick.accurateMarket){
          // 客户营销 - 精准营销 - 精准营销
          url = "/marketing/marketing/accurate_market";
        }else{
          url = goUrlClick.accurateMarketUrl
        }
        index = 3;
      } else if (type == 1) {
        if(goUrlClick.goodsRepurchase){
           // 客户营销 - 自动化营销 - 商品复购
           url = "/marketing/auto_marketing/goods_repurchase";
        }else{
           url = goUrlClick.goodsRepurchaseUrl
        }
        index = 2;
      } else if (type === 2) {
        // 指定号码发送
        // url = "/marketing/marketing/designated_send";
         if(goUrlClick.conversionUnpurchasedMembers){
            url = "/marketing/auto_marketing_official/auto_market_official_module";
         }else{
            url = goUrlClick.conversionUnpurchasedMembersUrl
         }
         index = 3;
      }else if(type === 3){
         if(goUrlClick.callCustomerChurn){
            url = "/marketing/auto_marketing_official/auto_market_official_module";
         }else{
            url = goUrlClick.callCustomerChurnUrl
         }
         index = 3;
      } else if ( type === 4 ) {
        if(goUrlClick.expediting){
           url = "/orderCare/orderCare/expediting";  
        }else{
           url = goUrlClick.expeditingUrl
          console.log('25698',url)
        }
        index = 1;
      } else if(type === 5){
          if(goUrlClick.autoEvaluation){   
             url = "/orderCare/comtCare/autoEvaluation";
          }else{
             url = goUrlClick.autoEvaluationUrl
          }
         index = 1;
      }else if (type == 12) {
         if(goUrlClick.goodsRepurchase){
            // url = this.venderType ? "/marketing/auto_marketing_official/first_purchase_official" : "/marketing/auto_marketing/first_purchase";
            url = "/marketing/auto_marketing/goods_repurchase";
         }else{
            url =  goUrlClick.goodsRepurchaseUrl
         }
            index = 3;
      } else if (type == 13) {
        if(goUrlClick.conversionUnpurchasedMembers){
          url = "/marketing/auto_marketing_official/auto_market_official_module";
        }else{
          url =  goUrlClick.conversionUnpurchasedMembersUrl
        }
        index = 3;
      } else if (type == 14) {
        // 客户流失唤醒
         if(goUrlClick.conversionUnpurchasedMembers){
          url = "/marketing/auto_marketing_official/auto_market_official_module";
         }else{
          url =  goUrlClick.conversionUnpurchasedMembersUrl
        }
        index = 3;
   
      } else if (type == 15) {
        // 自动催评
        // url = "/orderCare/comtCare/thankEvaluationOfficial";
       if(goUrlClick.expediting){
          url = "/orderCare/orderCare/expediting";
       }else{
          url = goUrlClick.expeditingUrl
       }
       index = 2;
      } else if (type == 16) {
        // 自动催评
        if(goUrlClick.autoEvaluation){
          url = "/orderCare/comtCare/autoEvaluation";
       }else{
          url = goUrlClick.autoEvaluationUrl
       }
        index = 2;
      }

      // this.bus.$emit("topActive", { index: index, item: this.$store.state.route[index]});
      this.bus.$emit("topHeader", {
        index: index,
        item: this.$store.state.route[index],
      });
      this.$router.push({
        path: url,
      });
    },
    // 会员分布Echarts初始化
    drawactivityEcharts() {
      this.myChart = this.$echarts.init(this.$refs.activityEcharts);
      let options = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        color: ["#7F85E9", "#5882FB", "#FF872F", "#FE4D45", "#4CDFC0"],
        legend: {
          data: ["活动（PV）", "活动（UV）", "参与人次", "参与人数", "新增人数"],
          textStyle: {
            fontSize: 12,
            color: "#7F85E9",
          },
          y: "bottom",
        },
        grid: {
          y: 10,
          left: "0",
          right: "0",
          bottom: "12%",
          containLabel: true,
        },
        xAxis: {
          // x轴配置
          type: "category",
          boundaryGap: true,
          axisLabel: {
            textStyle: {
              fontSize: 12,
              color: "#999",
            },
          },
          axisTick: {
            show: false,
          },
          axisLine: {
            show: false,
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: ["rgba(243, 243, 243, 1)"],
              type: "dashed",
            },
          },
          data: ["2019-11-10", "2019-11-12", "2019-11-14", "2019-11-16", "2019-11-18", "2019-11-20", "2019-11-22", "2019-11-25"],
        },
        yAxis: {
          // y轴配置
          type: "value",
          boundaryGap: ["10%", "0%"],
          axisLabel: {
            // formatter: '{value} k',
            textStyle: {
              fontSize: 12,
              color: "#999",
            },
          },
          axisLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: ["rgba(243, 243, 243, .8)"],
              type: "dashed",
            },
          },
        },
        series: [
          {
            name: "活动（PV）",
            type: "line",
            stack: "总量",
            symbol: "none",
            smooth: true,
            data: [222, 456, 222, 134, 789, 543, 321, 666],
            itemStyle: {
              normal: {
                lineStyle: {
                  color: "#7F85E9",
                  width: 1,
                },
                areaStyle: {
                  color: "rgba(127, 133, 233, .2)",
                },
              },
            },
          },
          {
            name: "活动（UV）",
            type: "line",
            stack: "总量",
            symbol: "none",
            smooth: true,
            data: [220, 456, 378, 666, 238, 778, 310, 555],
            itemStyle: {
              normal: {
                lineStyle: {
                  color: "#5882FB",
                  width: 1,
                },
                areaStyle: {
                  color: "rgba(88, 130, 251, .2)",
                },
              },
            },
          },
          {
            name: "参与人次",
            type: "line",
            stack: "总量",
            symbol: "none",
            smooth: true,
            data: [1088, 789, 567, 338, 666, 1111, 1288, 1566],
            itemStyle: {
              normal: {
                lineStyle: {
                  color: "#FF872F",
                  width: 1,
                },
                areaStyle: {
                  color: "rgba(255, 135, 47, .2)",
                },
              },
            },
          },
          {
            name: "参与人数",
            type: "line",
            stack: "总量",
            symbol: "none",
            smooth: true,
            data: [78, 789, 301, 334, 390, 330, 320, 789],
            itemStyle: {
              normal: {
                lineStyle: {
                  color: "#FE4D45",
                  width: 1,
                },
                areaStyle: {
                  color: "rgba(254, 77, 69, .2)",
                },
              },
            },
          },
          {
            name: "新增人数",
            type: "line",
            stack: "总量",
            symbol: "none",
            smooth: true,
            data: [820, 932, 901, 934, 1290, 1330, 1320, 1888],
            itemStyle: {
              normal: {
                lineStyle: {
                  color: "#4CDFC0",
                  width: 1,
                },
                areaStyle: {
                  color: "rgba(76, 223, 192, .2)",
                },
              },
            },
          },
        ],
      };
      this.myChart.setOption(options);
    },
  },
};
</script>

<style scoped lang="scss">
.footModule {
  .activityData {
    display: flex;
    flex-direction: column;
    height: 440px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
    border-radius: 6px;
    .head {
      flex-shrink: 0;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 30px 0 25px;
      height: 54px;
      border-bottom: 1px solid #f6f6f6;
      .item.active {
        &::before {
          content: "";
          position: absolute;
          left: 2px;
          bottom: -4px;
          width: 12px;
          height: 2px;
          background-color: #ff536b;
          // box-shadow:0px 2px 3px rgba(255,83,107,0.5);
          // animation: opacity .3s ease-in;
        }
        .txt {
          font-size: 14px;
          color: #333;
          font-weight: bold;
        }
      }
      @keyframes opacity {
        0% {
          opacity: 0;
        }
        100% {
          opacity: 1;
        }
      }
      .left {
        color: #333;
        font-size: 16px;
        font-weight: 800;
      }
      .right {
        display: flex;
        align-items: center;
        .li {
          margin-right: 27px;
          font-size: 14px;
          color: #999;
          font-weight: 400;
          cursor: pointer;
          transition: all 0.2s;
          &:hover {
            color: #fe4d45;
          }
          &:last-child {
            margin: 0;
          }
        }
        .li.active {
          position: relative;
          color: #fe4d45;
          font-weight: bold;
          &::before {
            content: "";
            position: absolute;
            left: 50%;
            bottom: -4px;
            transform: translateX(-50%);
            width: 24px;
            height: 2px;
            background: rgba(254, 77, 69, 1);
            box-shadow: 0px 2px 3px rgba(255, 83, 107, 0.5);
          }
        }
      }
    }
    .activityEchartsBox {
      flex: 1;
      box-sizing: border-box;
      padding: 25px 45px 15px 45px;
    }
  }
  .quickAccess {
    display: flex;
    flex-direction: column;
    height: 300px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
    border-radius: 6px;
    .title {
      flex-shrink: 0;
      box-sizing: border-box;
      height: 54px;
      line-height: 52px;
      border-bottom: 1px solid #f6f6f6;
      padding-left: 24px;
      color: #252c38;
      margin-bottom: 20px;
      font-size: 16px;
    }
    ul {
      // flex: 1;
      display: flex;
      flex-flow: wrap;
      align-items: center;
      justify-content: space-between;
      box-sizing: border-box;
      padding: 0 24px;
      .item {
        box-sizing: border-box;
        padding: 11px 17px;
        position: relative;
        display: flex;
        width: 33.33%;
        @media screen and (max-width: 1366px) {
          padding: 11px 0 11px 12px;
        }
        margin: 10px 0;
        // height: 100px;
        // box-shadow:0px 0px 12px rgba(0,0,0,0.06);
        border-radius: 4px;
        transition: all 0.1s;
        &:hover {
          box-shadow: 0px 0px 12px rgba(0, 0, 0, 0.12);
          .icon {
            opacity: 1;
          }
        }
        .right {
          margin-left: 16px;
          @media screen and (max-width: 1366px) {
            margin-right: 6px;
          }
          h5 {
            img {
              vertical-align: middle;
              margin-left: 4px;
            }
          }
        }
        cursor: pointer;
        h5 {
          margin: 0 0 6px 0;
          color: #333;
          font-weight: 500;
          font-size: 16px;
        }
        .desc {
          line-height: 20px;
          font-size: 13px;
          color: #999;
        }
        .icon-x {
          // position: absolute;
          // right: 0;
          // bottom: 0;
          width: 60px;
          height: 60px;
          // opacity: .3;
          transition: all 0.2s;
        }
      }
    }
  }
}
</style>
